import { IconTrigger } from '@components/icons/trigger';
import { StatusIndicator } from '@components/status-indicator';

import { User } from 'api/users/requests';

import { Assignees } from './assignees';

type TriggerMethodIndicatorProps = {
  isAutomatic?: boolean;
  assignees?: User[];
  /** Omitting this renders the indicator without a wrapper element. */
  automaticZIndex?: number;
};

export const TriggerMethodIndicator = ({
  isAutomatic,
  assignees,
  automaticZIndex,
}: TriggerMethodIndicatorProps) => {
  if (!isAutomatic) {
    return <Assignees assignees={assignees} />;
  }

  const indicator = <StatusIndicator variant="notStarted" icon={<IconTrigger />} />;

  if (automaticZIndex === undefined) {
    return indicator;
  }

  return <div style={{ position: 'relative', zIndex: automaticZIndex }}>{indicator}</div>;
};
